import {useMemo} from 'external/react'
import ContainerLayout from 'components/ContainerLayout'

import usePayment from 'context/payment-context/hook'
import usePublic from 'context/public-context/hook'

import SelectedCourse from './SelectedCourses/SelectedCourse'
import AddCourse from './SelectedCourses/AddCourse'

export default function Offer () {

	const {offerData: {elective}, params: {offerId}} = usePublic()
	const { selectedBasic, selectedElective, updateCart} = usePayment()

	const hasElectives = useMemo(() => elective && elective.length > 0, [elective])
	const description = useMemo(() => hasElectives > 0
		? "Selecciona hasta cinco cursos básicos, su oferta incluye electivas gratis."
		: "Selecciona hasta cinco cursos básicos."
	, [hasElectives])

	return (
		<ContainerLayout title="Personaliza tu experiencia de aprendizaje según tus preferencias" description={description} className="selectCourse">
			<div className='bodyTitle'>Materias Básicas</div>
			<div className='bodyList_Course'>
				{selectedBasic.map((id, index) => {
					if (id === false) return <AddCourse key={index} typeSubject='basic' idSelectCourse={index} />
					return <SelectedCourse id={id} key={index} index={index} type='basic' subject={id.substring(0, 2)} offer={offerId} language='es' onRemoveCourse={() => updateCart('basic', index, id, 'delete')} />
			})}
			</div>
			{hasElectives && (<>
				<div className='bodyTitle'>Electivas</div>
				<div className='bodyList_Course'>
				{selectedElective.map((id, index) => {
					if (id === false) return <AddCourse key={index} typeSubject='elective' idSelectCourse={index} />
					return <SelectedCourse id={id} key={index} index={index} type='elective' subject={id.substring(0, 2)} offer={offerId} language='es' onRemoveCourse={() => updateCart('elective', index, id, 'delete')} />

				})}
				</div>
			</>)}
		</ContainerLayout>
	)
}